import React from 'react';
import './Retardos.css';
import HeaderComponent from '../../components/Retardos/Header/Header'
import RetardosComponent from '../../components/Retardos/Retardos/Retardos';

const Retardos = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <HeaderComponent />
        </div>
        <div>
            <RetardosComponent />
        </div>
      </div>
    );
  };
  
export default Retardos;

